import React from 'react';


const SeparatorComponents = () => {
  return <hr />;
};


export default SeparatorComponents;
